<template>
    <div>
        <div class="simulator-box">

            <div class="card-panel">
                <div class="flex-row">
                    <div class="col-xs-12 col-sm">
                        <h2 class="simulator-title loaded" >
                            Configuração IRPF anual {{ ano }}
                        </h2>
                    </div>
                    <div class="col-xs-12 col-md-3 right-align">
                         <a  v-if="funcionario_cargo_id === 1" class="btn-floating btn-default " @click.prevent="form({ano})"> <i class="large material-icons">add</i></a>
                    </div>
                </div>
                <table class="responsive-table bordered striped">
                    <thead>
                        <tr>
                            <th>Base de cálculo anual</th>
                            <th>Alíquota</th>
                            <th>Parcela a deduzir no IR (R$)</th>
                            <th v-if="funcionario_cargo_id === 1">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in irpf_anuais" :key="`irpf-anual-${item.irpf_anual_id}`">
                            <td>
                                <template v-if="item.valor_minimo === null">
                                    Menor que {{ item.valor_maximo | dinheiro }}
                                </template>
                                <template v-else-if="item.valor_maximo == null">
                                    Acima de {{ item.valor_minimo | dinheiro }}
                                </template>
                                <template v-else>
                                    De {{ item.valor_minimo | dinheiro }} até {{ item.valor_maximo | dinheiro }}
                                </template>
                            </td>

                            <td>{{ item.aliquota }}%</td>
                            <td >{{ item.valor_parcela_deducao | dinheiro }}</td>
                            <td  width="100" v-if="funcionario_cargo_id === 1">
                                <a @click.prevent="excluir(item, index)" href class="text-primary">
                                    <i class="material-icons">delete</i>
                                </a>

                                <a href @click.prevent="form(item, index)" class="text-primary">
                                    <i class="material-icons">edit</i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-2 right-align">
                <router-link class="btn btn-default" :to="{name: 'configuracoes'}">Concluir</router-link>
            </div>


            <modal :is-active.sync="modal_form" :title="`${irpf_selecionado.irpf_anual_id ? 'Editar' : 'Cadastrar'} IRPF anual`">
                <form  @submit.prevent="salvar(irpf_selecionado)">
                    <div>

                        <div class="form-group">
                            <label>Modo da base de cálculo</label>

                            <div class="flex-row mb-2 mt-2">
                                <div class="col-xs-12 col-sm">
                                    <input name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="1" id="metodo-1"/>
                                    <label for="metodo-1">Normal</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-2" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="2"/>
                                    <label for="metodo-2">Menor que</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-3" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="3"/>
                                    <label for="metodo-3">Acima de</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="flex-row">
                                <div class="col-xs-12 col-sm" v-if="metodo != 2">
                                    <label>
                                        {{ metodo == 3 ? 'Acima de' : 'Mínimo' }}
                                    </label>
                                    <money class="form-control validate" v-model="irpf_selecionado.valor_minimo" placeholder="Valor mínimo" />

                                </div>
                                <div class="col-xs-2 col-sm" v-if="metodo != 3">
                                    <label>{{ metodo == 2 ? 'Menor que' : 'Máximo' }}</label>
                                    <money class="form-control" v-model="irpf_selecionado.valor_maximo" placeholder="Valor máximo" />
                                </div>
                            </div>

                            <div class="flex-row">
                                <div class="col-xs-12 col-sm">
                                    <label>Alíquota</label>
                                    <input type="number" step="0.1" min="0" class="form-control" v-model.number="irpf_selecionado.aliquota" placeholder="Alíquota">
                                </div>
                                <div class="col-xs-2 col-sm">
                                    <label>Parcela a deduzir no IR</label>
                                    <money class="form-control" v-model="irpf_selecionado.valor_parcela_deducao" placeholder="Parcela a deduzir no IR" />
                                </div>
                            </div>
                            <div class="right-align">
                                <button class="btn btn-default" type="submit">Salvar</button>
                            </div>
                        </div>
                    </div>
                </form>
            </modal>

        </div>
    </div>
</template>

<script>

import { api } from "@/helpers/api";

import swal from 'sweetalert2';


import Modal from "@/components/common/Modal/Base.vue";

import modal from "@/helpers/wm-modal";

import Auth from "@/store/auth";


export default  {

    components: { Modal },

    name: 'irpf-anual-form',


    async created() {

       await this.carregar();
    },


    computed: {
        ano() {
            return this.$route.params.ano;
        },

        usuario ()
        {
            return Auth.state.user;
        },

        funcionario () {
            return this.usuario.pessoa.funcionario;
        },

        funcionario_cargo_id() {
            return this.funcionario.funcionario_cargo_id;
        },
    },
    data() {

        return {
            metodo: 1,
            irpf_anuais: [],
            irpf_selecionado: {},
            modal_form: false
        }
    },

    methods: {

        async carregar() {
            const {data: {result: {data: irpf_anuais}}} = await api.get('irpf-anual', {params: {
                ano: this.ano
            }});

            this.irpf_anuais = irpf_anuais;
        },

        form(irpf) {

            this.irpf_selecionado = {...irpf};

            this.metodo = 1;

            if (irpf.valor_minimo === null){
                this.metodo = 2;
            } else if (irpf.valor_maximo === null) {
                this.metodo = 3;
            }

            this.modal_form = true;
        },


        async excluir(irpf, index)
        {

            const resultado = await modal.confirm({
                text: 'Confirma a exclusão desse item?'
            })

            if (! resultado) return;

            await api.delete(`irpf-anual/${irpf.irpf_anual_id}`);

            this.irpf_anuais.splice(index, 1);
        },

        async salvar()
        {

            const irpf = {...this.irpf_selecionado};

            if (this.metodo == 2) {
                irpf.valor_minimo = null;
            } else if (this.metodo == 3) {
                irpf.valor_maximo = null;
            }

            if (irpf.irpf_anual_id) {
                await api.put(`irpf-anual/${irpf.irpf_anual_id}`, irpf);
            } else {
                const {data: {result: {data: resultado}}} = await api.post('irpf-anual', irpf);
                this.irpf_anuais.push(resultado)
            }


            this.modal_form = false;

            this.carregar();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/irpf-anual/Form.vue